import { render, staticRenderFns } from "./GroupAddIcon.vue?vue&type=template&id=8c030c66&"
import script from "./GroupAddIcon.vue?vue&type=script&lang=ts&"
export * from "./GroupAddIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports